import AdyenBtn from '../../adyen-button';

const KlarnaPayBtn = () => {
    return <AdyenBtn
        paymentType='klarna_paynow'
        paymentMethodConfiguration={{
            useKlarnaWidget: true,
            type: 'klarna_paynow'
        }}
    />;
};

export default KlarnaPayBtn;
